const swiperSlider = {
	sliderContainer: ".js-slider-container",
	arrowNext: ".js-slider-arrow-next",
	arrowPrev: ".js-slider-arrow-prev",
	pagination: ".js-slider-pagination"
};

const slider_list = document.querySelectorAll(".js-slider");
let section_list = [];
[...slider_list].forEach(item => {section_list.push(item.dataset.sectionType)})


const swiperDatasets = {
	customOptions: "customOptions"
};
const swiperModifiers = {
	initialized: "initialized"
};

section_list.forEach(item => {
	if (!Shopify.theme.sections.registered[item]) {
		Shopify.theme.sections.register(item, {
			onLoad: function () {
				this.initSlider();
			},
			initSlider() {
				this.sliderContainer = this.container.querySelector(swiperSlider.sliderContainer);
		
				if (!this.sliderContainer) {
					return null;
				}
		
				let customOptions = this.container.dataset[swiperDatasets.customOptions];
				if (customOptions) {
					customOptions = JSON.parse(customOptions);
				}
		
				this.options = {
					slidesPerView: "auto",
					spaceBetween: 0,
					mousewheel: { 
						forceToAxis: true
					},
					scrollbar: {
						el: '.swiper-scrollbar',
						draggable: true
					},
					navigation: {
						nextEl: this.container.querySelector(swiperSlider.arrowNext),
						prevEl: this.container.querySelector(swiperSlider.arrowPrev)
					},
					pagination: {
						el: swiperSlider.pagination,
						type: "bullets",
						clickable: true
					},
					on: {
						afterInit: () => {
							this.sliderContainer.classList.add(swiperModifiers.initialized);
						}
					},
					...customOptions
				};
		
				this.slider1 = new Swiper(this.sliderContainer, this.options);
				this.slider1.init();
				this.slider1.on('slideChange', function (e) {
					const slider2 = e.wrapperEl;
					slider2.querySelectorAll("product-card-variants").forEach(item => {
						item.classList.remove("open");
					});
					slider2.querySelectorAll(".quick-add").forEach(item => {
						item.classList.remove("open");
					});
				});
			},
			onUnload: function () {
				if (!this.slider1) {
					return false;
				}
		
				this.slider1.destroy();
			}
		});

		Shopify.theme.sections.load(item);
	}
})
